import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/_components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/_components/Map/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/loading.tsx");
